<template>
  <div>
    <div style="display: flex;align-items: center;">
      <h3 style="margin-right: 50px;"># 等级列表</h3>
      <el-button type="primary" plain size="small" @click="handleEdit('新增')">新增等级</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column align="center" label="id" width="50" prop="levelId"></el-table-column>
      <el-table-column align="center" label="等级图标">
        <template slot-scope="scope">
          <el-image style="width: 64px; height: 37px" :src="scope.row.icon" fit="contain"></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="等级名称" prop="levelName"></el-table-column>
      <el-table-column align="center" label="升级所需经验" prop="experience">
      </el-table-column>
      <el-table-column align="center" label="升级赠送经验" prop="rewardsPoints"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit('编辑', scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" :disabled="scope.row.isEdit"
            @click.native.prevent="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: right;margin: 20px 20px 0 0;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next" :total="total_pages">
      </el-pagination>
    </div>

    <!-- 修改等级弹窗 -->
    <el-dialog :close-on-click-modal="false" :append-to-body="true" :title="modalTitle + '等级信息'"
      :visible.sync="gradeShow" width="35%" center>
      <el-form :model="gradeForm" :rules="rules" ref="gradeRls" label-width="130px" class="demo-ruleForm">
        <el-form-item label="等级名称" prop="levelName">
          <el-input v-model="gradeForm.levelName"></el-input>
        </el-form-item>
        <el-form-item label="等级图标" prop="icon">
          <el-upload class="avatar-uploader" :action="url" :headers="{ 'token': token }" :show-file-list="false"
            :on-success="handleFileSuccess">
            <img v-if="gradeForm.icon" :src="gradeForm.icon" style="width: 100px;height: 100px">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="升级所需经验值" prop="experience">
          <el-input type="number" v-model="gradeForm.experience"></el-input>
        </el-form-item>
        <el-form-item label="升级奖励的积分" prop="rewardsPoints">
          <el-input type="number" v-model="gradeForm.rewardsPoints" placeholder="默认为0"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editSubmitForm()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserGradeListApi, deleteGradeListApi, SetUserGradeApi } from '@/api/user.js'
import { uploadFileUrl } from "@/api/common";
import { getToken } from "@/utils/lostorage";
import { Message } from "element-ui";
export default {
  name: 'tabGrade',
  computed: {
    fileList() {
      return []
    },
    token() {
      return getToken()
    },
    url() {
      return uploadFileUrl;
    }
  },
  data() {
    return {
      modalTitle: '',
      searchParams: {
        pageNum: 1,
        pageSize: 10
      },
      total_pages: 0,
      gradeForm: {
        levelName: '',
        experience: 0,
        rewardsPoints: 0,
        icon: 0,
        levelId: ''
      },
      gradeShow: false,
      tableData: [],
      rules: {
        levelName: [
          { required: true, message: '请输入等级名称', trigger: 'blur' },
          { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
        ],
        icon: [{ required: true, message: '请添加等级图标', trigger: 'blur' }],
        experience: [{ required: true, message: '请填写升级所需要的经验值', trigger: 'blur' }],
        rewardsPoints: [{ required: true, message: '请填写升级所需要的经验值', trigger: 'blur' }]
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleFileSuccess(response) {
      this.gradeForm.icon = response.data.url
      Message.success("上传成功")
    },
    getList() {
      getUserGradeListApi(this.searchParams).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records
          this.total_pages = res.data.total
        } else {
          this.$message.error(res.msg ? res.msg : '获取等级列表失败!')
        }
      }).catch(e => {
        this.$message.error(e ? e : '获取等级列表失败!')
      })

    },
    // 等级列表删除事件
    async handleDelete(row) {
      try {
        this.$confirm('此操作将删除该用户等级, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await deleteGradeListApi(row.levelId)
          this.getList()
          this.$message({ type: 'success', message: '删除成功!' })
        }).catch(e => {
          this.$message.error(e ? e : '删除失败!')
        })

      } catch { }
    },
    handleCurrentChange(number) {
      this.searchParams.pageNum = number;
      this.getList();
    },
    handleSizeChange(size) {
      if (this.total_pages >= size) {
        this.searchParams.pageSize = size;
        this.getList();
      }
    },
    // 修改等级传值事件
    handleEdit(title, row) {
      this.modalTitle = title
      if (row?.levelId) {
        this.gradeForm = JSON.parse(JSON.stringify(row))
      } else {
        this.gradeForm = {
          levelName: '',
          experience: 0,
          rewardsPoints: 0,
          icon: 0,
          levelId: ''
        }
      }
      this.gradeShow = true

    },
    // 修改等级提交事件
    editSubmitForm() {
      this.$refs.gradeRls.validate(async (valid) => {
        if (valid) {
          const payload = { ...this.gradeForm }
          delete payload.levelBack
          SetUserGradeApi(payload).then(res => {
            Message.success("操作成功")
            this.gradeShow = false
            this.getList()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  min-width: 600px;
}

::v-deep .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
</style>
